import {Injectable} from '@angular/core';
import {CxEvent, EventService, ProductSearchPage, ProductSearchService} from '@spartacus/core';
import {NavigationEvent, SearchPageResultsEvent} from '@spartacus/storefront';
import {DcpFormatDataService} from './dcp-format-data.service';
import {DcpDataService} from './dcp-data.service';
import {CommonPropertiesService} from './common-properties.service';
import {AdobeTrackingData} from './models/adobe-tracking-data';
import {first, skip} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpPageHitDataService extends DcpDataService<AdobeTrackingData> {
  private excludedSemanticPages = ['search', 'product'];

  constructor(
    private formatDataService: DcpFormatDataService,
    private commonPropertiesService: CommonPropertiesService,
    private productSearchService: ProductSearchService,
    private eventService: EventService,
  ) {
    super();
  }

  public getData(event: CxEvent): AdobeTrackingData {
    if (!(event instanceof NavigationEvent)) {
      return undefined;
    }

    /*
     * WORKAROUND:
     * Spartacus seems to have an issue when directly accessing the search page,
     * the semanticRoute property can be undefined in those cases and SearchPageResultsEvent will not be fired.
     * This clause fixes that issue for tracking purposes.
     */
    if (event.semanticRoute === undefined && event.url?.includes('/search')) {
      event.semanticRoute = 'search';
      this.productSearchService.getResults().pipe(skip(1), first(), untilDestroyed(this)).subscribe(productSearchData => {
        productSearchData = productSearchData as ProductSearchPage;
        const searchEvent = new SearchPageResultsEvent();
        searchEvent.navigation = event;
        searchEvent.searchTerm = productSearchData.freeTextSearch;
        searchEvent.numberOfResults = productSearchData.pagination.totalResults;
        this.eventService.dispatch(searchEvent);
      });
    }
    if (this.excludedSemanticPages.includes(event.semanticRoute)) {
      return undefined;
    }
    return this.fillData(event);
  }

  public fillData(event: NavigationEvent, data?: AdobeTrackingData): AdobeTrackingData {
    if (!data) {
      data = {
        events: {},
      };
    }
    data.events.pageView = true;
    data.page = {
      url: window.location.href,
      referrer: document.referrer,
    };
    this.commonPropertiesService.fillCurrency(data);
    this.commonPropertiesService.fillLanguage(data);
    data.page.url = this.formatDataService.formatUrl(data.page.url);
    return data;
  }
}
